import {
  AfterViewInit, Component, ComponentFactoryResolver, ElementRef, OnChanges, OnDestroy,
  OnInit, SimpleChanges, TemplateRef, ViewChild, ViewContainerRef
} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {CarsService} from '../cars.service';
import {faHeart as fasFaHeart, faShoppingCart} from '@fortawesome/free-solid-svg-icons';
import {faHeart as farFaHeart} from '@fortawesome/free-regular-svg-icons';
import {CarDialogOverviewComponent} from '../../cars/car-dialog-overview/car-dialog-overview.component';
import {CarModalComponent} from '../../cars/car-modal/car-modal.component';
import {NbDialogConfig, NbDialogService} from '@nebular/theme';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {CalculatorCarsComponent} from '../../calculator/calculator-cars.component';
import {BehaviorSubject, forkJoin} from 'rxjs';
import {CalculatorService} from '../../calculator/calculator.service';
import {Overlay, OverlayRef} from '@angular/cdk/overlay';
import {TemplatePortal} from '@angular/cdk/portal';
import {AuthenticateService} from '../../auth/authenticate.service';
import {ChangeContext, LabelType, Options} from '@angular-slider/ngx-slider';
import {CurrencyPipe} from '@angular/common';
import {ActivatedRoute, Router} from '@angular/router';
import {switchMap} from 'rxjs/operators';
import {CognitoService} from '../../cognito.service';
import {LoginModalComponent} from '../../auth/login/login-modal.component';
import {AcceptTermsComponent} from '../../cars/accept-terms/accept-terms.component';
import {animate, query, stagger, style, transition, trigger} from '@angular/animations';
import {CookieService} from 'ngx-cookie-service';
import {faTags as fasTags, faCertificate as fasCertificate} from '@fortawesome/free-solid-svg-icons';
import {ArbitrageTermsGaComponent} from '../arbitrage-terms-ga/arbitrage-terms-ga.component';
import {CarModalSellerGaComponent} from '../car-modal-seller-ga/car-modal-seller-ga.component';
import {CarModalGaComponent} from '../car-modal/car-modal-ga.component';
import {NgcCookieConsentService} from 'ngx-cookieconsent';
import {calcCarClearance, Input as CarClearanceInput, Fuel, getManufactureYearFromDates} from '../rs-car-clearance';
// import {CarModalSellerComponent} from '../../cars/car-modal-seller/car-modal-seller.component';

// import {ComponentPortal, TemplatePortal} from '@angular/cdk/portal';

export interface Model {
  name: string;
  fuelType: string;
  fuelType_h: string;
}

export interface FilterMeta {
  year: number;
  make: string;
  make_h: string;
  model: Model[];
}

export interface DialogData {
  car: any;
}

const CAR_ID_TO_DEBUG = 1845438;
declare let dataLayer: Array<any>;

@Component({
  selector: 'app-cars-grid-seller-ga',
  templateUrl: './cars-grid-seller-ga.component.html',
  styleUrls: ['./cars-grid-seller-ga.component.scss'],
  animations: [
    trigger('fadeAnimation', [
      transition('* <=> *', [
        query(':enter', [
          style({opacity: 0}),
          stagger('100ms', animate('300ms ease-in', style({opacity: 1})))
        ], {optional: true}),
        query(':leave', [
          animate('300ms ease-out', style({opacity: 0}))
        ], {optional: true})
      ])
    ])
  ]
})
export class CarsGridSellerGaComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {

  @ViewChild('carContainer') carContainer: ElementRef;
  @ViewChild('loadingOverlay') loadingOverlay: TemplateRef<any>;

  fasTags = fasTags;
  faCertificate = fasCertificate;

  currencyPipe = new CurrencyPipe('he-il');
  target: any;

  overlayRef: OverlayRef;

  loading = false;
  hasMore = true;

  page = 1;

  freeZone: string = 'No';

  private sliderChangeTimer: any;
  private filterInProgress = false;
  private lastFilterValues = {
    priceLow: 0,
    priceHigh: 0,
    kmLow: 0,
    kmHigh: 0,
    tab: 0
  };

  // price range
  sliderValue = 0;
  sliderHighValue = 5000000;
  sliderOptions: Options = {
    floor: 0,
    ceil: 5000000,
    step: 10000,
    rightToLeft: true,
    animate: true,
    pushRange: true,
    animateOnMove: true,
    showSelectionBar: true,
    hideLimitLabels: false,
    autoHideLimitLabels: false,
    ticksTooltip: (value: number): string => {
      return '';
    },
    selectionBarGradient: {
      from: '#00ff00',
      to: '#ff0000'
    },
    translate: (value: number, label: LabelType): string => {
      return '';
    }

  };

  // private sliderChangeTimer: any;
  private lastSliderRange = {
    price: { low: 0, high: 0 },
    km: { low: 0, high: 0 }
  };

  // km range
  sliderKmValue = 0;
  sliderKmHighValue = 1000000;
  sliderKmOptions: Options = {
    floor: 0,
    ceil: 1000000,
    step: 10000,
    rightToLeft: true,
    animate: true,
    pushRange: true,
    animateOnMove: true,
    showSelectionBar: true,
    hideLimitLabels: false,
    autoHideLimitLabels: false,
    ticksTooltip: (value: number): string => {
      return '';
    },
    selectionBarGradient: {
      from: '#00ff00',
      to: '#ff0000'
    },
    translate: (value: number, label: LabelType): string => {
      return '';
    }

  };

  locatedInIsrael: 'All' | 'Yes' | 'No' = 'All';
  saleCondition: 'All' | 'New' | 'Used' = 'All';
  importType: 'Commercial' | 'Taxi' = 'Commercial';
  year = -1;
  make = '';
  model = '';
  fueltype = '';
  priceRange = '0-5000000';
  kmRange = '0-1000000';

  tabSelectionEnabled = true;
  selectedTab = 0;

  sellerId = 530;

  /**
   * Configuration constants for pricing.
   * For a production app, consider moving these to a configuration service or environment file.
   */
    // Example: 1 USD = 2.7 GEL (update periodically).
  public GEL_TO_USD_RATE = 2.7;
  // A placeholder for other costs (e.g., shipping, insurance, US-side fees) in USD.
  private readonly SHIPPING_AND_OTHER_FEES_USD = 2500 + 2500;


  constructor(
    private activatedRoute: ActivatedRoute,
    private carsService: CarsService,
    private calculatorService: CalculatorService,
    private cognitoService: CognitoService,
    public dialogService: NbDialogService,
    private breakpointObserver: BreakpointObserver,
    public dialog: MatDialog,
    private componentFactoryResolver: ComponentFactoryResolver,
    private overlay: Overlay,
    private viewContainerRef: ViewContainerRef,
    private authService: AuthenticateService,
    private router: Router,
    private el: ElementRef,
    private cookieService: CookieService,
    private cookieConsentService: NgcCookieConsentService,
    // private componentPortal: ComponentPortal<LoadingSpinnerComponent>
  ) {
    // Specify LoadingSpinnerComponent
    // const loadingPortal = new ComponentPortal<LoadingSpinnerComponent>(LoadingSpinnerComponent);
  }

  get isUAERoute(): boolean {
    return this.router.url.startsWith('/ga');
  }

  @ViewChild('host', {read: ViewContainerRef}) host: ViewContainerRef;
  // calcRef: ComponentRef<CalculatorCarsComponent>;
  isLoading = new BehaviorSubject<boolean>(false);
  vehicleValue = new BehaviorSubject<any>(null);

  fasFaHeart = fasFaHeart;
  farFaHeart = farFaHeart;
  // faCartPlus = faCartPlus;
  faShoppingCart = faShoppingCart;


  cars = [];
  damagedCars: any[] = [];
  fetchedCars = [];
  fetchedDamagedCars = [];
  currencies: any;
  carById: any; // fetched by link id, since we work by random and filter

  filterMetaCars: any[] = [];
  filterMetaYears: any[] = [];
  filterMetaMakes = [];
  filterMetaFuelTypes = [];
  filterMetaModels = [];

  // filterMetaModels = [];

  // --- Normal filters ---
  filterMetaNormal: any = {};
  yearsNormal = ['All'];
  makesNormal = ['All'];
  modelsNormal = ['All'];
  fuelTypesNormal = ['All'];
  selectedYearNormal = 'All';
  selectedMakeNormal = 'All';
  selectedModelNormal = 'All';
  selectedFuelTypeNormal = 'All';

  // --- Damaged filters ---
  filterMetaDamaged: any = {};
  yearsDamaged = ['All'];
  makesDamaged = ['All'];
  modelsDamaged = ['All'];
  fuelTypesDamaged = ['All'];
  selectedYearDamaged = 'All';
  selectedMakeDamaged = 'All';
  selectedModelDamaged = 'All';
  selectedFuelTypeDamaged = 'All';

  // protected readonly faMapMarkerAlt = faMapMarkerAlt;

  years = ['All'];
  makes = ['All'];
  models = ['All'];
  fuelTypes = ['All'];

  selectedYear = 'All';
  selectedMake = 'All';
  selectedModel = 'All';
  selectedFuelType = 'All';

  isFilterCollapsed = false;

  isDialogOpen = false;
  showDirham = true;

  async ngOnInit() {
    try {
      await this.updateGelToUsdRate();  // Wait for the latest rate
    } catch (err) {
      console.warn('Failed to update GEL rate, using default.');
    }


    if (this.isUAERoute) {
      this.cookieConsentService.hasConsented();
      this.cookieConsentService.close(false);
      this.cookieConsentService.destroy();
    }

    setTimeout(() => {
      this.selectedTab = parseInt(this.cookieService.get('selectedTab') || '0', 0);
    }, 10);

    dataLayer.push({
      event: 'button_click_toggle_Tab_pub',
      item_id: +this.selectedTab,
      item_name: +this.selectedTab === 0 ? 'public market' : 'public collector',
      // item_price: 0,
      // item_year: car.ManufactureDate,
      user_id: sessionStorage.getItem('user-id') ?? -1,
      userId: sessionStorage.getItem('user-id') ?? -1,
    });
    this.isFilterCollapsed = this.isMobileView();
    // this.showDirham = sessionStorage.getItem('user-id') === '530';
    // window.addEventListener('scroll', this.onWindowScroll, true);
    // this.initialize();
  }

  ngOnChanges(changes: SimpleChanges) {
    // if (changes.selected && changes.selected.currentValue === true) {
    //   window.addEventListener('scroll', this.onWindowScroll, true);
    //   // this.updateOnTabSelection();
    // } else {
    //   window.removeEventListener('scroll', this.onWindowScroll, true);
    // }
  }

  ngOnDestroy() {
    // window.removeEventListener('scroll', this.onWindowScroll, true);
  }

  /**
   * Fetch the current GEL to USD rate from exchangerate.fun and update GEL_TO_USD_RATE.
   * If the fetch fails, log a warning and retain the default rate.
   */
  async updateGelToUsdRate(): Promise<void> {
    try {
      const response = await fetch('https://api.exchangerate.fun/latest?base=USD');
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const data = await response.json();
      if (data && data.result === 'success' && typeof data.rates?.gel === 'number') {
        this.GEL_TO_USD_RATE = data.rates.gel;
      } else if (data && typeof data.rates?.GEL === 'number') {
        // fallback: sometimes currency codes are uppercase
        this.GEL_TO_USD_RATE = data.rates.GEL;
      } else {
        console.warn('Could not find GEL rate in exchange API response; using default rate.');
        this.GEL_TO_USD_RATE = 2.7;
      }
    } catch (err) {
      console.warn('Failed to fetch GEL to USD rate, using default rate.', err);
    }
  }

  /**
   * A helper function to map the `car.FuelType` string to the `Fuel` enum required by the calculator.
   */
  private mapCarFuelTypeToEnum(fuelType: string): Fuel {
    const lowerFuel = (fuelType || '').toLowerCase();
    if (lowerFuel.includes('hybrid')) {
      return 'hybrid';
    }
    if (lowerFuel.includes('electric')) {
      return 'electric';
    }
    if (lowerFuel.includes('diesel')) {
      return 'diesel';
    }
    return 'petrol'; // default to petrol/benzin
  }

  /**
   * Calculates the total "landed cost" of a car in Georgia, including the vehicle price,
   * shipping, and Georgian customs duties. Always returns the result in GEL.
   *
   * @param car The car object. Expected properties:
   *            - `car.CarPrice`: base price in USD.
   *            - `car.ProductionYear`: year of manufacture.
   *            - `car.EngineSize`: engine displacement in liters.
   *            - `car.FuelType`: string ("Gasoline", "Diesel", "Hybrid", "Electric").
   *            - `car.Steering`: "Left" or "Right".
   *
   * @returns The total landed cost in GEL.
   */
  public getCarPrice(car: any): number {
    // --- Step 0: Validate input ---
    // debugger;
    if (!car || typeof car.C_Price_Georgia !== 'number') {
      console.error('getCarPrice: Invalid or incomplete car object provided.', car);

    } else {
      return car.C_Price_Georgia;
    }
    // debugger;

    if (!car || typeof car.CarPrice !== 'number') {
      console.error('getCarPrice: Invalid or incomplete car object provided.', car);
      return 0;
    }
    // Resolve manufacture year: prefer FirstUseDate, then ManufactureDate, else fallback to numeric ProductionYear
    const resolvedYear = getManufactureYearFromDates(car) ?? Number(car.ProductionYear);
    if (!resolvedYear || isNaN(resolvedYear) || resolvedYear < 1900) {
      console.error('getCarPrice: Unable to resolve a valid manufacture year from FirstUseDate/ManufactureDate/ProductionYear.', {
        FirstUseDate: car.FirstUseDate,
        ManufactureDate: car.ManufactureDate,
        ProductionYear: car.ProductionYear
      });
      return 0;
    }


    // Resolve engine liters with default fallback (1.5L) when missing/invalid
    const engineLiters =
      typeof car.EngineSize === 'number' && car.DisplacementLiters > 0 ? car.DisplacementLiters : 1.5;
    if (engineLiters === 1.5) {
      console.warn('getCarPrice: EngineSize missing/invalid; defaulting to 1.5L.');
    }


    // --- Step 1: Prepare customs clearance input ---
    const clearanceInput: CarClearanceInput = {
      manufactureYear: resolvedYear,
      engineLiters,
      fuel: this.mapCarFuelTypeToEnum(car.FuelType),
      rightWheelMoved: car.Steering?.toLowerCase() === 'right',
    };


    // --- Step 2: Calculate customs duties in GEL ---
    const clearanceBreakdown = calcCarClearance(clearanceInput, car);
    const clearanceCostGEL = clearanceBreakdown.totalGEL;


    // --- Step 3: Convert customs cost to USD (for consistency in landed cost calc) ---
    const clearanceCostUSD = clearanceCostGEL / this.GEL_TO_USD_RATE;

    // --- Step 4: Total landed cost in USD ---
    const totalLandedCostUSD =
      car.CarPrice + this.SHIPPING_AND_OTHER_FEES_USD + clearanceCostUSD;

    if (car.id == CAR_ID_TO_DEBUG) {
      console.log('clearanceCostUSD', clearanceCostUSD);
      console.log('resolvedYear', resolvedYear);
      console.log('engineLiters', engineLiters);
      console.log('clearanceInput', clearanceInput);
      console.log('clearanceBreakdown', clearanceBreakdown);
      console.log('clearanceCostGEL', clearanceCostGEL);
      console.log('totalLandedCostUSD', totalLandedCostUSD);
      console.log('price in Gel', Math.round(totalLandedCostUSD * this.GEL_TO_USD_RATE));
    }

    // --- Step 5: Always return in GEL ---
    return Math.round(totalLandedCostUSD * this.GEL_TO_USD_RATE);
  }

  // getCarPrice(car: any) {
  //   if (this.showDirham) {
  //     if (this.freeZone === 'Yes') {
  //       return (this.castUSDToDirham(car.CarPrice + 2500 + 2500 + 1350));
  //     } else {
  //       return (this.castUSDToDirham(car.CarPrice + 2500)  * 1.05  * 1.05 + this.castUSDToDirham(3850)); // 1350 + 2500
  //     }
  //   } else {
  //     return car.C_Price;
  //   }
  // }

  castUSDToDirham(usd: number): number {
    const conversionRate = 3.67; // Example conversion rate, please use the current rate
    return usd * conversionRate;
  }

  // Method to convert EUR to Dirham
  castEURToDirham(eur: number): number {
    const conversionRate = 4.05; // Example conversion rate, please use the current rate
    return eur * conversionRate;
  }

  // onScroll(event: any): void {
  //   const element = event.target;
  //   console.log(`scrollTop: ${element.scrollTop}, scrollHeight: ${element.scrollHeight}
  //   , offsetHeight: ${element.offsetHeight}, clientHeight: ${element.clientHeight}`);
  //   if (element.scrollHeight - element.scrollTop <= element.clientHeight + 1) {
  //     console.log('load  0 -------');
  //     // Reached the bottom of the scrollable area
  //     if (!this.isLoading) {
  //       console.log('load -------');
  //       // this.loadMoreItems();
  //     }
  //   }
  // }


  resetScroll = () => {
    // this.target?.removeEventListener('scroll', this.onWindowScroll, true);
    // this.target?.scrollTo({ top: 0, behavior: 'smooth' });
    // this.target?.addEventListener('scroll', this.onWindowScroll, true);
  }

  onWindowScroll = (event: any): void => {

    if (this.isDialogOpen) {
      return;
    }

    // console.log(event);
    // const element = document.getElementById('cardContainer');
    const element = event.target;

    this.target = element;
    if (element) {
      const pos = element.scrollTop + element.offsetHeight;
      const max = element.scrollHeight;

      if (pos >= max) {
        console.log('load ---------');
        // Your logic to load more items or whatever you want to do when reaching the bottom


        const params = {
          page: this.page + 1,
          year: this.year,
          make: this.make,
          model: this.model,
          fueltype: this.fueltype,
          priceRange: this.priceRange,
          kmRange: this.kmRange,
          locatedInIsrael: this.locatedInIsrael,
          saleCondition: this.saleCondition,
          importType: this.importType,
          userId: this.sellerId
        };

        // console.log(pos, max);


        this.loadMoreItems(params);

      }
    }
  }

  handleLoadMore = (): void => {
    if (this.isDialogOpen) {
      return;
    }


    console.log('load ---------');
    // Your logic to load more items or whatever you want to do when reaching the bottom


    const params = {
      page: this.page + 1,
      year: this.year,
      make: this.make,
      model: this.model,
      fueltype: this.fueltype,
      priceRange: this.priceRange,
      kmRange: this.kmRange,
      locatedInIsrael: this.locatedInIsrael,
      saleCondition: this.saleCondition,
      importType: this.importType,
      userId: this.sellerId
    };


    this.loadMoreItems(params);

  }


  async initialize() {
    // await this.checkUserAuthentication();
    this.createOverlay();
    this.loadData();
  }

  async checkUserAuthentication() {
    const userId = sessionStorage.getItem('user-id');
    if (!userId) {
      this.authService.checkAuth().subscribe((res: any) => {
        if (res.code === 200) {
          sessionStorage.setItem('user-id', res.data.id);
          // Your dataLayer logic
        }
      });
    }
  }

  createOverlay() {
    this.overlayRef = this.overlay.create({
      hasBackdrop: true,
      backdropClass: 'loading-backdrop',
      positionStrategy: this.overlay
        .position()
        .flexibleConnectedTo(this.carContainer)
        .withPositions([
          {
            originX: 'center',
            originY: 'center',
            overlayX: 'center',
            overlayY: 'center',
          },
        ]),
    });

    const loadingPortal = new TemplatePortal(this.loadingOverlay, this.viewContainerRef);
    this.overlayRef.attach(loadingPortal);
  }

  loadData() {
    forkJoin([
      this.carsService.filterPagedUAE({
        page: 1, year: this.year, make: this.make, model: this.model, fueltype: this.fueltype,
        priceRange: this.priceRange, kmRange: this.kmRange,
        locatedInIsrael: this.locatedInIsrael, saleCondition: this.saleCondition,
        importType: this.importType, userId: this.sellerId
      }),
      this.carsService.getFilterMetaUAE(this.sellerId, 'uae'),
      this.carsService.filterPagedDamagedUAE({
        page: 1, year: this.year, make: this.make, model: this.model, fueltype: this.fueltype,
        priceRange: this.priceRange, kmRange: this.kmRange,
        locatedInIsrael: this.locatedInIsrael, saleCondition: this.saleCondition,
        importType: this.importType, userId: this.sellerId
      }),
      this.carsService.getFilterMetaSalvaged()
    ]).subscribe(([cars, filterMetaNormal, damagedCars, filterMetaDamaged]) => {

      // --- Normal Cars ---
      this.cars = cars.map(car => ({ ...car, isLiked: car.interest === 'Liked' }));
      this.fetchedCars = this.cars;
      this.filterMetaNormal = filterMetaNormal;

      this.yearsNormal = ['All'].concat(filterMetaNormal.years || []);
      this.makesNormal = ['All'].concat(filterMetaNormal.manufacturers?.map(m => m.make) || []);
      this.modelsNormal = ['All'].concat(
        [].concat(...(filterMetaNormal.cars?.map(v => v.model.map(m => m.name)) || []))
      );
      this.fuelTypesNormal = ['All'].concat(filterMetaNormal.fueltypes?.map(f => f.label) || []);

      // --- Damaged Cars ---
      this.damagedCars = damagedCars.map(car => ({ ...car, isLiked: car.interest === 'Liked' }));
      this.filterMetaDamaged = filterMetaDamaged;

      this.yearsDamaged = ['All'].concat(filterMetaDamaged.years || []);
      this.makesDamaged = ['All'].concat(filterMetaDamaged.manufacturers?.map(m => m.make) || []);
      this.modelsDamaged = ['All'].concat(
        [].concat(...(filterMetaDamaged.cars?.map(v => v.model.map(m => m.name)) || []))
      );
      this.fuelTypesDamaged = ['All'].concat(filterMetaDamaged.fueltypes?.map(f => f.label) || []);

      // --- Shared filters (compatibility for legacy dropdowns) ---
      this.filterMetaCars = filterMetaNormal.cars;
      this.filterMetaModels = [].concat(...this.filterMetaCars?.map(vehicle => vehicle.model) || []);
      this.filterMetaFuelTypes = ['All'].concat(filterMetaNormal.fueltypes || []);
      this.filterMetaYears = ['All'].concat(filterMetaNormal.years || []);
      this.filterMetaMakes = filterMetaNormal.manufacturers;

      // Shared simple lists (default to normal tab)
      this.years = this.yearsNormal;
      this.makes = this.makesNormal;
      this.models = this.modelsNormal;
      this.fuelTypes = this.fuelTypesNormal;

      // --- Finalize ---
      this.overlayRef.detach();
      this.handleQueryParams();
      this.hasMore = cars.length !== 0;
    });
  }

  loadDataOld() {
    forkJoin([
      this.carsService.filterPagedUAE({
        page: 1,
        year: this.year,
        make: this.make,
        model: this.model,
        fueltype: this.fueltype,
        priceRange: this.priceRange,
        kmRange: this.kmRange,
        locatedInIsrael: this.locatedInIsrael,
        saleCondition: this.saleCondition,
        importType: this.importType,
        userId: this.sellerId
      }),
      // this.calculatorService.getCurrencies(),
      this.carsService.getFilterMetaUAE(this.sellerId, 'uae'),
      this.carsService.filterPagedDamagedUAE({
        page: 1,
        year: this.year,
        make: this.make,
        model: this.model,
        fueltype: this.fueltype,
        priceRange: this.priceRange,
        kmRange: this.kmRange,
        locatedInIsrael: this.locatedInIsrael,
        saleCondition: this.saleCondition,
        importType: this.importType,
        userId: this.sellerId
      }),
    ]).subscribe(([cars, filterMeta, damagedCars]) => {
      this.cars = cars.map((car) => ({
        ...car,
        isLiked: car.interest === 'Liked'
      }));
      this.fetchedCars = this.cars;

      this.damagedCars = damagedCars.map((car) => ({
        ...car,
        isLiked: car.interest === 'Liked'
      }));

      // this.currencies = currencies.data;
      console.log(filterMeta);
      this.filterMetaCars = filterMeta.cars;

      // debugger;

      this.filterMetaModels = [].concat(...this.filterMetaCars?.map(vehicle => vehicle.model) || []);

      this.filterMetaFuelTypes = ['All'].concat(filterMeta.fueltypes || []);
      this.fuelTypes = ['All'].concat(filterMeta.fueltypes?.map((fuelType) => fuelType.label) || []);
      this.filterMetaYears = ['All'].concat(filterMeta.years || []);


      this.filterMetaMakes = filterMeta.manufacturers;
      this.makes = ['All'].concat(filterMeta.manufacturers?.map((manufacturer) => manufacturer.make) || []);
      // console.log(this.cars);
      // console.log(new Date().getTime());

      this.overlayRef.detach();

      this.handleQueryParams();

      this.hasMore = cars.length !== 0;
    });
  }

  loadDamagedCars() {
    this.carsService.filterPagedDamagedUAE({
      page: 1,
      year: this.year,
      make: this.make,
      model: this.model,
      fueltype: this.fueltype,
      priceRange: this.priceRange,
      kmRange: this.kmRange,
      locatedInIsrael: this.locatedInIsrael,
      saleCondition: this.saleCondition,
      importType: this.importType,
      userId: this.sellerId
    }).subscribe((damagedCars: any) => {
      this.damagedCars = damagedCars.map((car) => ({
        ...car,
        isLiked: car.interest === 'Liked'
      }));
    });
  }

  handleQueryParams() {

    this.activatedRoute.queryParams
      .pipe(
        switchMap(async (params) => {
          const id = params['id'];
          this.importType = params['importType'] ?? 'Commercial';
          // this.selectedTab = +params['tab'] ?? 0;
          this.selectedTab = params['tab'] !== undefined ? +params['tab'] : this.selectedTab;
          if (id) {
            return await this.getCarDataById(id);
          }
          const dialogResult = this.carsService.carResponseSubject.value;
          if (dialogResult) {
            dataLayer.push({
              event: 'cars-grid-dialog-closed_coll_pub',
              item_id: dialogResult.id,
              item_name: dialogResult.Manufacturer + ' ' + dialogResult.Model,
              item_price: dialogResult.CarPrice,
              item_year: dialogResult.ManufactureDate,
            });
          }
          return null;
        })
      )
      .subscribe(
        (carData) => {
          if (carData) {
            this.toggleMoreInfo(carData).then(() => {
            });
          }
        },
        (error) => {
          console.error(`An error occurred: ${error}`);
        }
      );
  }

  loadMoreItems(params: any) {
    const isDamagedTab = this.selectedTab === 1;

    const apiCall = isDamagedTab
      ? this.carsService.filterPagedDamagedUAE(params)
      : this.carsService.filterPagedUAE(params);

    apiCall.subscribe((cars: any) => {
      if (isDamagedTab) {
        this.damagedCars = [
          ...this.damagedCars,
          ...cars.map((car) => ({ ...car, isLiked: car.interest === 'Liked' }))
        ];
        this.fetchedDamagedCars = this.damagedCars;
      } else {
        this.cars = [
          ...this.cars,
          ...cars.map((car) => ({ ...car, isLiked: car.interest === 'Liked' }))
        ];
        this.fetchedCars = this.cars;
      }

      this.page++;
      this.hasMore = cars.length !== 0;
      console.log('page', this.page);
    });
  }

  loadMoreItems0(params: any) {
    this.carsService.filterPagedUAE(params).subscribe(cars => {
      this.cars = [...this.cars, ...cars.map((car) => ({
        ...car,
        isLiked: car.interest === 'Liked'
      }))
      ];
      this.fetchedCars = this.cars;
      this.page++;

      console.log('page', this.page);
      console.log(this.cars);
      this.hasMore = cars.length !== 0;
    });
  }

  // async getCarDataById(id: string, customerType: string = 'Commercial'): Promise<any> {
  //   let carById = this.cars.find((car) => car.id === +id);
  //   if (!carById) {
  //     const cars = await this.carsService.getCarByIdNew(+id, customerType).toPromise();
  //     carById = cars[0];
  //   }
  //   return carById;
  // }

  async getCarDataById(id: string, customerType: string = 'Commercial'): Promise<any> {
    let carById = this.cars.find((car) => car.id === +id)
      || this.damagedCars.find((car) => car.id === +id);
    if (!carById) {
      const cars = await this.carsService.getCarByIdNew(+id, customerType).toPromise();
      carById = cars[0];
    }
    return carById;
  }

  ngAfterViewInit() {
    const userId = sessionStorage.getItem('user-id');
    // const dialog = this.dialog.open(AcceptTermsComponent, {
    //   width: '100%'
    // });
    // dialog.afterClosed().subscribe(result => {
    //   if (!result) {
    //     this.router.navigate(['/account/calculate']);
    //   }
    //   if (result.approve) {
    this.initialize();
    this.isLoading.next(true);
    const factory = this.componentFactoryResolver.resolveComponentFactory(CalculatorCarsComponent);

    //     this.isLoading.next(false);
    //   } else {
    //     this.router.navigate(['/auth/login']);
    //   }
    // });
  }

  openDialog(car: any): void {
    this.dialog.open(CarDialogOverviewComponent, {
      width: '80vw',
      data: {car}
    });
  }

  toggleLike(car) {
    car.isLiked = !car.isLiked;
    const interest = car.isLiked ? 'Liked' : 'Disliked';
    this.carsService.updateUAEInterest(car.id, interest, this.importType).subscribe((res: any) => {
      console.log(res);
    });
  }

  toggleInterest(car) {
    this.carsService.updateUAEInterest(car.id, 'Interested', this.importType).subscribe((res: any) => {
      console.log(res);
    });
  }

  isMobileView(): boolean {
    return this.breakpointObserver.isMatched(Breakpoints.Handset);
  }

  async handleClick(car: any) {
    await this.router.navigate([], {
      queryParams: {
        id: car.id,
        importType: this.importType,
        tab: this.selectedTab
      },
      queryParamsHandling: 'merge'
    });
  }

  async toggleMoreInfo(car: any) {

    try {
      // debugger;
      let selectedCar = car;

      dataLayer.push({
        event: 'button_click_more_info_list_coll_pub',
        item_id: selectedCar.id,
        item_name: selectedCar.Manufacturer + ' ' + selectedCar.Model,
        item_price: selectedCar.CarPrice,
        item_year: selectedCar.ManufactureDate,
        user_id: sessionStorage.getItem('user-id') ?? -1,
        userId: sessionStorage.getItem('user-id') ?? -1,
      });

      const isMobile = this.isMobileView();

      const dialogConfig: NbDialogConfig<any> = {
        hasBackdrop: true,
        closeOnEsc: true,
        backdropClass: '',
        dialogClass: isMobile ? 'full-screen-dialog' : '',
        closeOnBackdropClick: false,
        hasScroll: false,
        autoFocus: true,
        viewContainerRef: undefined,
        context: {
          isCarMarket: true,
          source: 'personal',
          data: selectedCar ?? {},
          currencies: this.currencies,
          isLoadingCalc: this.isLoading,
          vehicleValue: this.vehicleValue,
          importType: this.importType,
        }
      };

      if (!isMobile) {
        const dialogRef = this.dialogService.open(CarModalSellerGaComponent, dialogConfig);

        // this.carsService.updateInterest(selectedCar.id, 'RequestedMoreInfo', this.importType).subscribe((res: any) => {
        //   console.log(res);
        // });

        dialogRef.onClose.subscribe((result: any) => {

          this.router.navigate([], {
            queryParams: {
              id: null,
              importType: this.importType,
              tab: this.selectedTab,
            },
            queryParamsHandling: 'merge'
          });

          // Action to be performed when the dialog closes
          const dialogResult = result ?? dialogConfig.context.data;
          console.log('Dialog closed', dialogResult);

          dataLayer.push({
            event: 'cars-grid-dialog-closed_coll_pub',
            item_id: dialogResult.id,
            item_name: dialogResult.Manufacturer + ' ' + dialogResult.Model,
            item_price: dialogResult.CarPrice,
            item_year: dialogResult.ManufactureDate,
          });

        });

      } else {
        const dialogRef = this.dialogService.open(CarModalGaComponent, dialogConfig);
        dialogRef.componentRef.instance.nbDialogRef = dialogRef; // Set the dialogRef in the component

        // this.carsService.updateInterest(selectedCar.id, 'RequestedMoreInfo', this.importType).subscribe((res: any) => {
        //   console.log(res);
        // });

        dialogRef.onClose.subscribe((result: any) => {

          this.router.navigate([], {
            queryParams: {
              id: null,
              importType: this.importType,
              tab: this.selectedTab,
            },
            queryParamsHandling: 'merge'
          });

          // Action to be performed when the dialog closes
          const dialogResult = result ?? dialogConfig.context.data;
          console.log('Dialog closed', dialogResult);

          dataLayer.push({
            event: 'cars-grid-dialog-closed_coll_pub',
            item_id: dialogResult.id,
            item_name: dialogResult.Manufacturer + ' ' + dialogResult.Model,
            item_price: dialogResult.CarPrice,
            item_year: dialogResult.ManufactureDate,
          });

        });
      }

    } catch (err) {
      console.log(err);
      // user does not exist:
      // const loginRequest = this.dialog.open(CarsMarketLoginComponent, {});
      this.isDialogOpen = true;
      const loginRequest = this.dialog.open(LoginModalComponent,
        {
          width: this.isMobileView() ? '400px' : '450px',
          panelClass: 'custom-dialog-padding'
        });
      loginRequest.afterClosed().subscribe(async (res) => {

        if (!res || !res.approve) {
          // this.router.navigate(['/account']);
        } else {
          const selectedCar = await this.carsService.getCarById(car.id, 'personal').toPromise();

          this.router.navigate([], {
            relativeTo: this.activatedRoute,
            queryParams: {
              id: selectedCar.id,
              importType: this.importType,
              tab: this.selectedTab,
            },
            queryParamsHandling: 'merge'
          });

          dataLayer.push({
            event: 'button_click_more_info_list_coll_pub',
            item_id: selectedCar.id,
            item_name: selectedCar.Manufacturer + ' ' + selectedCar.Model,
            item_price: selectedCar.CarPrice,
            item_year: selectedCar.ManufactureDate,
            user_id: sessionStorage.getItem('user-id') ?? -1,
            userId: sessionStorage.getItem('user-id') ?? -1,
          });

          const isMobile = this.isMobileView();

          const dialogConfig: NbDialogConfig<any> = {
            hasBackdrop: true,
            closeOnEsc: true,
            backdropClass: '',
            dialogClass: isMobile ? 'full-screen-dialog' : '',
            closeOnBackdropClick: false,
            hasScroll: false,
            autoFocus: false,
            viewContainerRef: undefined,
            context: {
              data: car ?? {},
              currencies: this.currencies,
              isLoadingCalc: this.isLoading,
              vehicleValue: this.vehicleValue,
              importType: this.importType,
            }
          };

          // this.calculate(car);
          // check vin
          // this.carsService.vinCheck({vin: selectedCar.vin, listingId: selectedCar.listingId}).subscribe((res: any) => {
          //   if (res.res === 'found') {
          const self = this;
          // const loadingSubscription = this.isLoading.subscribe(isLoading => {
          //   // if (!isLoading) {
          //   //   this.vehicleValue.next(self.calculate(car) || {});
          //   // }
          // });

          const dialogRef = this.dialogService.open(CarModalComponent, dialogConfig);

          if (isMobile) {
            dialogRef.componentRef.instance.nbDialogRef = dialogRef; // Set the dialogRef in the component
          }

          // this.carsService.updateInterest(selectedCar.id, 'RequestedMoreInfo', this.importType).subscribe((res: any) => {
          //   console.log(res);
          // });

          dialogRef.onClose.subscribe((result: any) => {

            this.router.navigate([], {
              queryParams: {
                id: null,
                importType: this.importType,
                tab: 0
              },
              queryParamsHandling: 'merge'
            });

            // Action to be performed when the dialog closes
            const dialogResult = result ?? dialogConfig.context.data;
            console.log('Dialog closed', dialogResult);

            dataLayer.push({
              event: 'cars-grid-dialog-closed_coll_pub',
              item_id: dialogResult.id,
              item_name: dialogResult.Manufacturer + ' ' + dialogResult.Model,
              item_price: dialogResult.CarPrice,
              item_year: dialogResult.ManufactureDate,
            });

            if (result?.code === 200) {
              // this.refreshCars();
              // this.cars$.subscribe(
              //     (res: any) => {
              //         this.carsList = res;
              //         console.log(this.carsList);
              //     }
              // );
            }
            // loadingSubscription.unsubscribe();
            // this.vehicleValue.next(null);
          });
          // }
          //   else {
          //     alert('הרכב נמכר ולא נמצא במאגר');
          //   }
          // });
          this.isDialogOpen = false;
        }
      });

    }

  }

  getExwByExwId(data: any, id) {
    for (const option of data.options) {
      for (const exw of option.exw) {
        if (exw.id === id) {
          return exw;
        }
      }
    }

    return null;
  }

  getHarborByExwId(data, id) {
    return data.options.find(option =>
      option.exw.some(exw => exw.id === id)
    );
  }

  getDisHarborByExwId = (data, id) => {
    for (const option of data.options) {
      for (const exw of option.exw) {
        if (exw.id === id) {
          return exw.dHarbor;
        }
      }
    }

    return null;
  }

  onYearChange0(year: string) {
    this.selectedYear = year;
    // this.selectedMake = 'All';
    // this.selectedModel = 'All';
    // this.selectedFuelType = 'All';
  }

  onMakeChange0(make: string) {
    this.selectedMake = make;
    console.log('selected make', this.selectedMake);
    console.log('filterMetaCars', this.filterMetaCars);
    // debugger;
    this.models = Array.from(new Set(
      ['All'].concat(
        this.filterMetaCars
          .filter((car) => car.make === make)
          .map((car) => car.model.map((model: any) => model.name))
          .reduce((acc, val) => acc.concat(val), [])
      )
    ));

    this.selectedModel = 'All';


  }

  onModelChange0(model: string) {
    this.selectedModel = model;
  }

  onFuelChange0(fuel: string) {
    this.selectedFuelType = fuel;
  }

  onYearChange(year: string) {
    if (this.selectedTab === 1) {
      this.selectedYearDamaged = year;
    } else {
      this.selectedYearNormal = year;
    }
  }

  onMakeChange(make: string) {
    if (this.selectedTab === 1) {
      this.selectedMakeDamaged = make;
      this.modelsDamaged = Array.from(new Set(
        ['All'].concat(
          this.filterMetaDamaged.cars
            .filter((car) => car.make === make)
            .map((car) => car.model.map((m: any) => m.name))
            .reduce((acc, val) => acc.concat(val), [])
        )
      ));
      this.selectedModelDamaged = 'All';
    } else {
      this.selectedMakeNormal = make;
      this.modelsNormal = Array.from(new Set(
        ['All'].concat(
          this.filterMetaNormal.cars
            .filter((car) => car.make === make)
            .map((car) => car.model.map((m: any) => m.name))
            .reduce((acc, val) => acc.concat(val), [])
        )
      ));
      this.selectedModelNormal = 'All';
    }
  }

  onModelChange(model: string) {
    if (this.selectedTab === 1) {
      this.selectedModelDamaged = model;
    } else {
      this.selectedModelNormal = model;
    }
  }

  onFuelChange(fuel: string) {
    if (this.selectedTab === 1) {
      this.selectedFuelTypeDamaged = fuel;
    } else {
      this.selectedFuelTypeNormal = fuel;
    }
  }

  toggleFilter() {
    this.isFilterCollapsed = !this.isFilterCollapsed;
  }

  filter(type: string = 'normal') {
    this.loading = true;

    const isDamagedTab = this.selectedTab === 1;
    const activeMakes = isDamagedTab ? this.makesDamaged : this.makesNormal;
    const activeSelectedMake = isDamagedTab ? this.selectedMakeDamaged : this.selectedMakeNormal;
    const activeSelectedModel = isDamagedTab ? this.selectedModelDamaged : this.selectedModelNormal;
    const activeSelectedFuelType = isDamagedTab ? this.selectedFuelTypeDamaged : this.selectedFuelTypeNormal;
    const activeYear = isDamagedTab ? this.selectedYearDamaged : this.selectedYearNormal;

    this.overlayRef = this.overlay.create({
      hasBackdrop: true,
      backdropClass: 'loading-backdrop',
      positionStrategy: this.overlay.position()
        .flexibleConnectedTo(this.carContainer)
        .withPositions([{ originX: 'center', originY: 'center', overlayX: 'center', overlayY: 'center' }])
    });

    const loadingPortal = new TemplatePortal(this.loadingOverlay, this.viewContainerRef);
    this.overlayRef.attach(loadingPortal);

    // Handle “normal” filtering (both tabs)
    if (['normal', 'damaged'].includes(type)) {
      const params = {
        page: 1,
        year: activeYear === 'All' ? -1 : parseInt(activeYear, 10),
        make: activeSelectedMake === 'All' ? '' : activeSelectedMake,
        model: activeSelectedModel === 'All' ? '' : activeSelectedModel,
        fueltype: activeSelectedFuelType === 'All' ? '' : activeSelectedFuelType,
        priceRange: `${this.sliderValue}-${this.sliderHighValue}`,
        kmRange: `${this.sliderKmValue}-${this.sliderKmHighValue}`,
        locatedInIsrael: this.locatedInIsrael,
        saleCondition: this.saleCondition,
        importType: this.importType,
        userId: this.sellerId
      };

      const apiCall = isDamagedTab
        ? this.carsService.filterPagedDamagedUAE(params)
        : this.carsService.filterPagedUAE(params);

      apiCall.subscribe((cars: any) => {
        if (isDamagedTab) {
          this.damagedCars = cars.map(c => ({ ...c, isLiked: c.interest === 'Liked' }));
        } else {
          this.cars = cars.map(c => ({ ...c, isLiked: c.interest === 'Liked' }));
          this.fetchedCars = this.cars;
        }
        this.loading = false;
        this.overlayRef.detach();
        this.resetScroll();
      });
    }

    // Handle "liked" and "interested" independently
    else if (type === 'interested') {
      this.carsService.filterInterested({}).subscribe((cars: any) => {
        this.cars = cars.map(c => ({ ...c, isLiked: c.interest === 'Liked' || c.interest === 'RequestedMoreInfo' }));
        this.fetchedCars = this.cars;
        this.loading = false;
        this.overlayRef.detach();
        this.resetScroll();
      });
    }

    else if (type === 'liked') {
      this.carsService.filterLiked({}).subscribe((cars: any) => {
        this.cars = cars.map(c => ({ ...c, isLiked: true }));
        this.fetchedCars = this.cars;
        this.loading = false;
        this.overlayRef.detach();
        this.resetScroll();
      });
    }
  }

  // type = normal | interested | liked | damaged
  filter_old1(type: string = 'normal') {
    this.loading = true;

    const isDamagedTab = this.selectedTab === 1;
    const activeMakes = isDamagedTab ? this.makesDamaged : this.makesNormal;
    const activeSelectedMake = isDamagedTab ? this.selectedMakeDamaged : this.selectedMakeNormal;
    const activeSelectedModel = isDamagedTab ? this.selectedModelDamaged : this.selectedModelNormal;
    const activeSelectedFuelType = isDamagedTab ? this.selectedFuelTypeDamaged : this.selectedFuelTypeNormal;
    const activeYear = isDamagedTab ? this.selectedYearDamaged : this.selectedYearNormal;

    // Show overlay
    this.overlayRef = this.overlay.create({
      hasBackdrop: true,
      backdropClass: 'loading-backdrop',
      positionStrategy: this.overlay
        .position()
        .flexibleConnectedTo(this.carContainer)
        .withPositions([{
          originX: 'center',
          originY: 'center',
          overlayX: 'center',
          overlayY: 'center'
        }])
    });


    const loadingPortal = new TemplatePortal(this.loadingOverlay, this.viewContainerRef);

    // const loadingPortal = new ComponentPortal(this.loadingOverlay);
    this.overlayRef.attach(loadingPortal);

    if (type === 'normal') {
      const year = this.selectedYear === 'All' ? -1 : parseInt(this.selectedYear, 0);
      const make = this.selectedMake === 'All' ? '' : this.filterMetaMakes.find((m: any) => m.make === this.selectedMake)?.make ?? '';

      // TODO: fix this
      const model = this.selectedModel === 'All' ? '' : this.selectedModel;

      // TODO: fix this
      let fueltype = '';
      switch (this.selectedFuelType) {
        case 'All':
          fueltype = '';
          break;
        case 'דיזל':
          fueltype = 'diesel';
          break;
        case 'בנזין':
          fueltype = 'petrol';
          break;
        case 'היברידי':
          fueltype = 'hybrid';
          break;
        case 'חשמלי':
          fueltype = 'electric';
          break;
        case 'פלאג אין':
          fueltype = 'plug-in';
          break;

      }
      // const fueltype = this.selectedFuelType === 'All'
      //     ? ''
      //     : this.filterMetaModels.find((m: any) => m?.fuelType_h === this.selectedFuelType)?.fuelType ?? '';

      this.year = year;
      this.make = make;
      this.model = model;
      this.fueltype = this.selectedFuelType;
      this.priceRange = `${this.sliderValue}-${this.sliderHighValue}`;
      this.kmRange = `${this.sliderKmValue}-${this.sliderKmHighValue}`;

      const params = {
        page: 1,
        year: activeYear === 'All' ? -1 : parseInt(activeYear, 10),
        make: activeSelectedMake === 'All' ? '' : activeSelectedMake,
        model: activeSelectedModel === 'All' ? '' : activeSelectedModel,
        fueltype: activeSelectedFuelType === 'All' ? '' : activeSelectedFuelType,
        priceRange: `${this.sliderValue}-${this.sliderHighValue}`,
        kmRange: `${this.sliderKmValue}-${this.sliderKmHighValue}`,
        locatedInIsrael: this.locatedInIsrael,
        saleCondition: this.saleCondition,
        importType: this.importType,
        userId: this.sellerId
      };

      const apiCall = isDamagedTab
        ? this.carsService.filterPagedDamagedUAE(params)
        : this.carsService.filterPagedUAE(params);

      apiCall.subscribe((cars: any) => {
        if (isDamagedTab) {
          this.damagedCars = cars.map(car => ({ ...car, isLiked: car.interest === 'Liked' }));
        } else {
          this.cars = cars.map(car => ({ ...car, isLiked: car.interest === 'Liked' }));
          this.fetchedCars = this.cars;
        }
        this.loading = false;
        this.overlayRef.detach();
        this.resetScroll();
      });

        // this.carsService.filterPagedUAE({
        //   page: 1,
        //   year: this.year,
        //   make: this.make,
        //   model: this.model,
        //   fueltype: this.fueltype,
        //   priceRange: `${this.sliderValue}-${this.sliderHighValue}`,
        //   kmRange: `${this.sliderKmValue}-${this.sliderKmHighValue}`,
        //   locatedInIsrael: this.locatedInIsrael,
        //   saleCondition: this.saleCondition,
        //   importType: this.importType,
        //   userId: this.sellerId
        // })
        //   .subscribe((cars: any) => {
        //     this.cars = cars.map((car) => ({
        //       ...car,
        //       isLiked: car.interest === 'Liked'
        //     }));
        //     this.fetchedCars = this.cars;
        //     this.filterByRange();
        //     this.loading = false;
        //     this.toggleFilter();
        //     this.overlayRef.detach();
        //     console.log('reset scroll call');
        //     this.resetScroll();
        //     this.hasMore = cars.length !== 0;
        //   });
    } else if (type === 'interested') {
      this.carsService.filterInterested({})
        .subscribe((cars: any) => {
          this.cars = cars.map((car) => ({
            ...car,
            isLiked: car.interest === 'Liked' || car.interest === 'RequestedMoreInfo'
          }));
          this.fetchedCars = this.cars;
          this.filterByRange();
          this.loading = false;
          this.toggleFilter();
          this.overlayRef.detach();
          this.resetScroll();
        });

    } else if (type === 'liked') {
      this.carsService.filterLiked({})
        .subscribe((cars: any) => {
          this.cars = cars.map((car) => ({
            ...car,
            isLiked: true, // car.interest === 'Liked'
          }));
          this.fetchedCars = this.cars;
          this.filterByRange();
          this.loading = false;
          this.toggleFilter();
          this.overlayRef.detach();
          this.resetScroll();
        });
    } else if (type === 'damaged') {
      const year = this.selectedYear === 'All' ? -1 : parseInt(this.selectedYear, 0);
      const make = this.selectedMake === 'All' ? '' : this.filterMetaMakes.find((m: any) => m.make === this.selectedMake)?.make ?? '';
      const model = this.selectedModel === 'All' ? '' : this.selectedModel;
      let fueltype = '';
      switch (this.selectedFuelType) {
        case 'All':
          fueltype = '';
          break;
        case 'דיזל':
          fueltype = 'diesel';
          break;
        case 'בנזין':
          fueltype = 'petrol';
          break;
        case 'היברידי':
          fueltype = 'hybrid';
          break;
        case 'חשמלי':
          fueltype = 'electric';
          break;
        case 'פלאג אין':
          fueltype = 'plug-in';
          break;
      }
      this.year = year,
        this.make = make,
        this.model = model,
        this.fueltype = this.selectedFuelType,
        this.priceRange = `${this.sliderValue}-${this.sliderHighValue}`,
        this.kmRange = `${this.sliderKmValue}-${this.sliderKmHighValue}`,

        this.carsService.filterPagedDamagedUAE({
          page: 1,
          year: this.year,
          make: this.make,
          model: this.model,
          fueltype: this.fueltype,
          priceRange: `${this.sliderValue}-${this.sliderHighValue}`,
          kmRange: `${this.sliderKmValue}-${this.sliderKmHighValue}`,
          locatedInIsrael: this.locatedInIsrael,
          saleCondition: this.saleCondition,
          importType: this.importType,
          userId: this.sellerId
        })
        .subscribe((damagedCars: any) => {
          this.damagedCars = damagedCars.map((car) => ({
            ...car,
            isLiked: car.interest === 'Liked'
          }));
          this.loading = false;
          this.toggleFilter();
          this.overlayRef.detach();
          this.resetScroll();
        });
    }
  }

  // filterDamaged(type: string = 'normal') {
  //   // this.loading = true;
  //   // // Show overlay
  //   // this.overlayRef = this.overlay.create({
  //   //   hasBackdrop: true,
  //   //   backdropClass: 'loading-backdrop',
  //   //   positionStrategy: this.overlay
  //   //     .position()
  //   //     .flexibleConnectedTo(this.carContainer)
  //   //     .withPositions([{
  //   //       originX: 'center',
  //   //       originY: 'center',
  //   //       overlayX: 'center',
  //   //       overlayY: 'center'
  //   //     }])
  //   // });
  //
  //
  //   // const loadingPortal = new TemplatePortal(this.loadingOverlay, this.viewContainerRef);
  //
  //   // const loadingPortal = new ComponentPortal(this.loadingOverlay);
  //   // this.overlayRef.attach(loadingPortal);
  //
  //   if (type === 'normal') {
  //     const year = this.selectedYear === 'All' ? -1 : parseInt(this.selectedYear, 0);
  //     const make = this.selectedMake === 'All' ? '' : this.filterMetaMakes.find((m: any) => m.make === this.selectedMake)?.make ?? '';
  //
  //     // TODO: fix this
  //     const model = this.selectedModel === 'All' ? '' : this.selectedModel;
  //
  //     // TODO: fix this
  //     let fueltype = '';
  //     switch (this.selectedFuelType) {
  //       case 'All':
  //         fueltype = '';
  //         break;
  //       case 'דיזל':
  //         fueltype = 'diesel';
  //         break;
  //       case 'בנזין':
  //         fueltype = 'petrol';
  //         break;
  //       case 'היברידי':
  //         fueltype = 'hybrid';
  //         break;
  //       case 'חשמלי':
  //         fueltype = 'electric';
  //         break;
  //       case 'פלאג אין':
  //         fueltype = 'plug-in';
  //         break;
  //
  //     }
  //     // const fueltype = this.selectedFuelType === 'All'
  //     //     ? ''
  //     //     : this.filterMetaModels.find((m: any) => m?.fuelType_h === this.selectedFuelType)?.fuelType ?? '';
  //
  //     this.year = year,
  //       this.make = make,
  //       this.model = model,
  //       this.fueltype = this.selectedFuelType,
  //       this.priceRange = `${this.sliderValue}-${this.sliderHighValue}`,
  //       this.kmRange = `${this.sliderKmValue}-${this.sliderKmHighValue}`,
  //
  //       this.carsService.filterPagedDamagedUAE({
  //         page: 1,
  //         year: this.year,
  //         make: this.make,
  //         model: this.model,
  //         fueltype: this.fueltype,
  //         priceRange: `${this.sliderValue}-${this.sliderHighValue}`,
  //         kmRange: `${this.sliderKmValue}-${this.sliderKmHighValue}`,
  //         locatedInIsrael: this.locatedInIsrael,
  //         saleCondition: this.saleCondition,
  //         importType: this.importType,
  //         userId: this.sellerId
  //       })
  //         .subscribe((cars: any) => {
  //           this.damagedCars = cars.map((car) => ({
  //             ...car,
  //             isLiked: car.interest === 'Liked'
  //           }));
  //           this.fetchedDamagedCars = this.cars;
  //           this.filterByRange();
  //           this.loading = false;
  //           this.toggleFilter();
  //           this.overlayRef.detach();
  //           console.log('reset scroll call');
  //           this.resetScroll();
  //           this.hasMore = cars.length !== 0;
  //         });
  //   } else if (type === 'interested') {
  //     this.carsService.filterInterested({})
  //       .subscribe((cars: any) => {
  //         this.damagedCars = cars.map((car) => ({
  //           ...car,
  //           isLiked: car.interest === 'Liked' || car.interest === 'RequestedMoreInfo'
  //         }));
  //         this.fetchedCars = this.cars;
  //         this.filterByRange();
  //         this.loading = false;
  //         this.toggleFilter();
  //         this.overlayRef.detach();
  //         this.resetScroll();
  //       });
  //
  //   } else if (type === 'liked') {
  //     this.carsService.filterLiked({})
  //       .subscribe((cars: any) => {
  //         this.damagedCars = cars.map((car) => ({
  //           ...car,
  //           isLiked: true, // car.interest === 'Liked'
  //         }));
  //         this.fetchedCars = this.cars;
  //         this.filterByRange();
  //         this.loading = false;
  //         this.toggleFilter();
  //         this.overlayRef.detach();
  //         this.resetScroll();
  //       });
  //   } else if (type === 'damaged') {
  //     const year = this.selectedYear === 'All' ? -1 : parseInt(this.selectedYear, 0);
  //     const make = this.selectedMake === 'All' ? '' : this.filterMetaMakes.find((m: any) => m.make === this.selectedMake)?.make ?? '';
  //     const model = this.selectedModel === 'All' ? '' : this.selectedModel;
  //     let fueltype = '';
  //     switch (this.selectedFuelType) {
  //       case 'All':
  //         fueltype = '';
  //         break;
  //       case 'דיזל':
  //         fueltype = 'diesel';
  //         break;
  //       case 'בנזין':
  //         fueltype = 'petrol';
  //         break;
  //       case 'היברידי':
  //         fueltype = 'hybrid';
  //         break;
  //       case 'חשמלי':
  //         fueltype = 'electric';
  //         break;
  //       case 'פלאג אין':
  //         fueltype = 'plug-in';
  //         break;
  //     }
  //     this.year = year,
  //       this.make = make,
  //       this.model = model,
  //       this.fueltype = this.selectedFuelType,
  //       this.priceRange = `${this.sliderValue}-${this.sliderHighValue}`,
  //       this.kmRange = `${this.sliderKmValue}-${this.sliderKmHighValue}`,
  //
  //       this.carsService.filterPagedDamagedUAE({
  //         page: 1,
  //         year: this.year,
  //         make: this.make,
  //         model: this.model,
  //         fueltype: this.fueltype,
  //         priceRange: `${this.sliderValue}-${this.sliderHighValue}`,
  //         kmRange: `${this.sliderKmValue}-${this.sliderKmHighValue}`,
  //         locatedInIsrael: this.locatedInIsrael,
  //         saleCondition: this.saleCondition,
  //         importType: this.importType,
  //         userId: this.sellerId
  //       })
  //         .subscribe((damagedCars: any) => {
  //           this.damagedCars = damagedCars.map((car) => ({
  //             ...car,
  //             isLiked: car.interest === 'Liked'
  //           }));
  //           this.loading = false;
  //           this.toggleFilter();
  //           this.overlayRef.detach();
  //           this.resetScroll();
  //         });
  //   }
  // }

  // isMobileView() {
  //   // Return true if the screen width is less than or equal to 768px, otherwise false
  //   return window.innerWidth <= 768;
  // }

  onSliderChangeEnd(type: 'price' | 'km', $event: ChangeContext) {
    if (this.filterInProgress) return; // skip re-entry

    clearTimeout(this.sliderChangeTimer);

    // Detect redundant ranges (no need to re-filter)
    const sameValues =
      this.lastFilterValues.priceLow === this.sliderValue &&
      this.lastFilterValues.priceHigh === this.sliderHighValue &&
      this.lastFilterValues.kmLow === this.sliderKmValue &&
      this.lastFilterValues.kmHigh === this.sliderKmHighValue &&
      this.lastFilterValues.tab === this.selectedTab;

    if (sameValues) return;

    // Save last values snapshot
    this.lastFilterValues = {
      priceLow: this.sliderValue,
      priceHigh: this.sliderHighValue,
      kmLow: this.sliderKmValue,
      kmHigh: this.sliderKmHighValue,
      tab: this.selectedTab
    };

    this.sliderChangeTimer = setTimeout(() => this.safeFilterByRange(), 300);
  }

  private async safeFilterByRange() {
    if (this.filterInProgress) return;

    this.filterInProgress = true;
    try {
      this.filterByRange();
    } finally {
      this.filterInProgress = false;
    }
  }

  onSliderChangeEnd1(type: 'price' | 'km', $event: ChangeContext) {
    clearTimeout(this.sliderChangeTimer);

    // Prevent redundant triggers if same range
    const last = this.lastSliderRange[type];
    if (last.low === $event.value && last.high === $event.highValue) {
      return;
    }

    this.lastSliderRange[type] = {
      low: $event.value,
      high: $event.highValue
    };

    // Debounce filtering to avoid multiple re-renders
    this.sliderChangeTimer = setTimeout(() => {
      this.filterByRange();
    }, 300);
  }

  onSliderChangeEnd_old($event: ChangeContext) {
    console.log($event);
    // this.sliderValue = $event.value;
    // this.sliderHighValue = $event.highValue;
    this.filterByRange();
    console.log(this.cars.length);
  }

  onSliderKmChangeEnd($event: ChangeContext) {
    console.log($event);
    // this.sliderValue = $event.value;
    // this.sliderHighValue = $event.highValue;
    this.filterByRange();
    console.log(this.cars.length);
  }

  onKmSliderEnd(event: ChangeContext) {
    this.sliderKmValue = event.value;
    this.sliderKmHighValue = event.highValue;
    this.applyRangeFilterSafely();
  }

  filterByRange() {
    const isDamagedTab = this.selectedTab === 1;
    const baseCars = isDamagedTab ? this.damagedCars : this.fetchedCars;

    const filtered = baseCars.filter((car) => {
      const price = car.C_Price_Georgia ?? car.C_Price ?? 0;
      const km = car.Mileage ?? 0;

      const inPriceRange = price >= this.sliderValue && price <= this.sliderHighValue;
      const inKmRange = km >= this.sliderKmValue && km <= this.sliderKmHighValue;

      return inPriceRange && inKmRange;
    });

    if (isDamagedTab) {
      this.damagedCars = filtered;
    } else {
      this.cars = filtered;
    }
  }

  filterByRange2() {
    const isDamagedTab = this.selectedTab === 1;
    const baseCars = isDamagedTab ? this.damagedCars : this.fetchedCars;

    const filtered = baseCars.filter((car) => {
      const price = car.C_Price_Georgia ?? car.C_Price ?? 0;
      const km = car.Mileage ?? 0;

      const inPriceRange = price >= this.sliderValue && price <= this.sliderHighValue;
      const inKmRange = km >= this.sliderKmValue && km <= this.sliderKmHighValue;

      return inPriceRange && inKmRange;
    });

    if (isDamagedTab) {
      this.damagedCars = filtered;
    } else {
      this.cars = filtered;
    }
  }

  onPriceSliderEnd(event: ChangeContext) {
    this.sliderValue = event.value;
    this.sliderHighValue = event.highValue;
    this.applyRangeFilterSafely();
  }

  private filterLock = false;
  private filterDebounce: any;


  private applyRangeFilterSafely() {
    if (this.filterLock) return;

    clearTimeout(this.filterDebounce);
    this.filterDebounce = setTimeout(() => {
      this.filterLock = true;

      try {
        this.filterByRange();
      } finally {
        setTimeout(() => (this.filterLock = false), 400);
      }
    }, 250);
  }

  filterByRange1() {
    const isDamagedTab = this.selectedTab === 1;
    const baseCars = isDamagedTab ? this.damagedCars : this.fetchedCars;

    const filtered = baseCars.filter((car) => {
      const price = car.C_Price_Georgia ?? car.C_Price ?? 0;
      const km = car.Mileage ?? 0;

      const inPriceRange = price >= this.sliderValue && price <= this.sliderHighValue;
      const inKmRange = km >= this.sliderKmValue && km <= this.sliderKmHighValue;

      return (
        inPriceRange &&
        inKmRange &&
        (
          (car.Location === 'Israel' && this.locatedInIsrael === 'Yes') ||
          (car.Location !== 'Israel' && this.locatedInIsrael === 'No') ||
          this.locatedInIsrael === 'All'
        ) &&
        (
          (car.SaleCondition === 'New' && this.saleCondition === 'New') ||
          (car.SaleCondition !== 'New' && this.saleCondition === 'Used') ||
          this.saleCondition === 'All'
        )
      );
    });

    if (isDamagedTab) {
      this.damagedCars = filtered;
    } else {
      this.cars = filtered;
    }
  }

  filterByRange_old() {
    this.cars = this.fetchedCars;
    console.log(this.cars);
    this.cars = this.cars.filter((car) => {
      return ((car.C_Price_Georgia ?? car.C_Price) >= this.sliderValue && (car.C_Price_Georgia ?? car.C_Price) <= this.sliderHighValue) &&
        (car.Mileage >= this.sliderKmValue && car.Mileage <= this.sliderKmHighValue) &&
        ((car.Location === 'Israel' && this.locatedInIsrael === 'Yes')
          || (car.Location !== 'Israel' && this.locatedInIsrael === 'No')
          || this.locatedInIsrael === 'All') &&
        ((car.SaleCondition === 'New' && this.saleCondition === 'New')
          || (car.SaleCondition !== 'New' && this.saleCondition === 'Used')
          || this.saleCondition === 'All');
      // && ((car.importType === 'Commercial' && this.saleCondition === 'Commercial')
    });
  }

  onLocationToggleChange($event: any): void {
    this.filterByRange();
  }

  onCarSaleConditionToggleChange($event: any): void {
    this.filterByRange();
  }

  onCarSaleFreeZoneToggleChange($event: any): void {
    // debugger;
    this.freeZone = $event.target.value;
  }

  onCarImportTypeToggleChange($event: any): void {
    this.router.navigate([], {
      queryParams: {
        id: null,
        importType: this.importType,
        tab: this.selectedTab
      },
      queryParamsHandling: 'merge'
    });
    this.filterByRange();
  }


  getFuelTypeHebrew(type: any) {
    if (this.showDirham) {
      return type;
    }

    switch (type) {
      case '':
        return '';
      case 'diesel':
        return 'דיזל';
      case 'petrol':
        return 'בנזין';
      case 'hybrid':
        return 'היברידי';
      case 'electric':
        return 'חשמלי';
      case 'plug-in':
        return 'פלאג אין';

    }
  }

  onTabIndexChanged($event: number) {
    this.selectedTab = (+$event || 0);
    this.cookieService.set('selectedTab', $event.toString());

    dataLayer.push({
      event: 'button_click_toggle_Tab_pub',
      item_id: $event,
      item_name: $event === 0 ? 'public market' : 'public collector',
      user_id: sessionStorage.getItem('user-id') ?? -1,
      userId: sessionStorage.getItem('user-id') ?? -1,
    });

    if (this.selectedTab === 1) {
      this.loadDamagedCars();
    }

    // Switch filter options and dropdown lists
    if (this.selectedTab === 0) {
      this.years = this.yearsNormal;
      this.makes = this.makesNormal;
      this.models = this.modelsNormal;
      this.fuelTypes = this.fuelTypesNormal;
      this.selectedYear = this.selectedYearNormal;
      this.selectedMake = this.selectedMakeNormal;
      this.selectedModel = this.selectedModelNormal;
      this.selectedFuelType = this.selectedFuelTypeNormal;
    } else {
      this.years = this.yearsDamaged;
      this.makes = this.makesDamaged;
      this.models = this.modelsDamaged;
      this.fuelTypes = this.fuelTypesDamaged;
      this.selectedYear = this.selectedYearDamaged;
      this.selectedMake = this.selectedMakeDamaged;
      this.selectedModel = this.selectedModelDamaged;
      this.selectedFuelType = this.selectedFuelTypeDamaged;
    }
  }

  onTabIndexChanged_Old($event: number) {
    this.selectedTab = (+$event || 0);
    this.cookieService.set('selectedTab', $event.toString());

    dataLayer.push({
      event: 'button_click_toggle_Tab_pub',
      item_id: $event,
      item_name: $event === 0 ? 'public market' : 'public collector',
      // item_price: 0,
      // item_year: car.ManufactureDate,
      user_id: sessionStorage.getItem('user-id') ?? -1,
      userId: sessionStorage.getItem('user-id') ?? -1,
    });

    // If Damaged/Salvaged tab is index 1, load damaged cars
    if (this.selectedTab === 1) {
      this.loadDamagedCars();
    }
    // if (this.selectedTab === 0) {
    //   window.addEventListener('scroll', this.onWindowScroll, true);
    //   // this.updateOnTabSelection();
    // } else {
    //   window.removeEventListener('scroll', this.onWindowScroll, true);
    // }
  }

  handleImageError(car: any): void {
    if (car.Source !== 'Manual') {
      car.url = null;
    } else {
      car.url = '/assets/images/nocarph.jpg';
    }
  }

  showArbDisclaimer(car: any) {
    const dialog = this.dialog.open(ArbitrageTermsGaComponent, {
      width: '100%'
    });
  }

  getArbitrageDiff(car: any): string | null {
    if (car.ArbitragePrice == null) {
      return null;
    }
    const diff = car.ArbitragePrice - car.C_Price;
    return diff > 0 ? `+${diff}` : null;
  }

}

